import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { VideoIcon } from '@calendly/ui/components/icons';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { isString } from 'lodash-es';
import { forwardRef } from 'react';
import { useTrack, TRACKING_EVENT_NAMES } from 'hooks/analytics_events';
import { isCalendlyMeeting } from 'shared/utils';
const containerIsPhoneCss = "cuhnpnw";
const containerCss = "cihpoy1";
const getEventLocationIfURL = location => {
  if (!isString(location)) return null;
  if (location.match(/^https?:\/\//)) {
    return location;
  }
  return null;
};
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(containerCss, {
    [containerIsPhoneCss]: isPhone
  }, props.className)} />;
});
export const EventActions = ({
  event,
  hasRealtimeFeatures = false,
  isMostRecentInProgress = false,
  trackFromContactPage = false,
  setHovered
}) => {
  const track = useTrack();
  const eventLocation = getEventLocationIfURL(event.location);
  const isPhone = useDeviceType('isPhone');
  const onJoinClick = e => {
    e.stopPropagation();
    e.preventDefault();
    const location = trackFromContactPage ? 'interactions_feed_all' : 'meetings_page';
    // Analytics event for contact page doesn't have a mi_event_uuid
    const miEventUuid = trackFromContactPage ? null : event.meetingIntelligence?.uuid;
    track({
      name: TRACKING_EVENT_NAMES.MEETING_INTERACTION,
      properties: {
        action: 'join',
        location,
        event_uuid: event.uuid,
        mi_event_uuid: miEventUuid,
        is_calendly_meeting: isCalendlyMeeting(event)
      }
    });
    window.open(eventLocation, '_blank', 'noopener,noreferrer');
  };
  let decoration = 'primary';
  if (hasRealtimeFeatures && !isMostRecentInProgress) {
    decoration = 'outline';
  }
  return <Container>
      {eventLocation && <Button onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)} onClick={onJoinClick} size="small" decoration={decoration} responsive={false} wide={isPhone}>
          <VideoIcon />
          {I18n.t('publisher.meetings.actions.join_meeting')}
        </Button>}
    </Container>;
};

require("./event_actions.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./event_actions.js");